export default __webpack_public_path__ + "static/blurBg-2979e54746e7d99466c771931229e573.jpg";